import * as React from 'react';
import { Radio as MuiRadio } from '@mui/material';
import { RadioProps as MuiRadioProps } from '@mui/material/Radio';
import { radioRoot } from 'ui/Radio/radioFormCssDefs';
import IconRadiobuttonSelected from './IconRadiobuttonSelected';
import IconRadiobuttonUnselected from './IconRadiobuttonUnselected';

export interface RadioProps extends Pick<MuiRadioProps, Exclude<keyof MuiRadioProps, 'color'>> {
  color?: 'primary';
}
/**
 * Use `Radio` for rendering a radio button, see stories for more complete examples
 *
 * ```js
 * import { Radio } from 'ui';
 * ```
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
const Radio: React.FunctionComponent<React.PropsWithChildren<RadioProps>> = ({
  color = 'primary',
  ...rest
}) => {
  return (
    <MuiRadio
      css={radioRoot}
      icon={<IconRadiobuttonUnselected fontSize={rest.size} />}
      checkedIcon={<IconRadiobuttonSelected fontSize={rest.size} />}
      color={color}
      {...rest}
    />
  );
};

export default Radio;
